import { z } from 'zod';

/**
 * Raporlar (ADR 0015): sales and profit, collections and supplier payments over a
 * period. The API returns plain rows; the console groups, totals and exports them.
 */

const isoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Tarihi seçin');

/** At most this many rows come back; the screen says so when there were more. */
export const REPORT_ROW_LIMIT = 5000;

export const reportRangeQuery = z
  .object({ from: isoDay, to: isoDay })
  .refine((r) => r.from <= r.to, { message: 'Başlangıç bitişten sonra olamaz', path: ['to'] });
export type ReportRangeQuery = z.input<typeof reportRangeQuery>;
